import React from 'react';
import colours from '../Colours';
import PropTypes from 'prop-types';

// To use this component, simply specify the icon name as the 'name' prop
// E.g. the IcArrowRight icon would be referenced as <Icon name="ArrowRight"/> (without the Ic prefix)
// You can also include the 'size' prop as follows: <Icon name="ArrowRight" size={24}/> (or size="24px")

import {
    EuAwd,
    EuElectric,
    EuHybrid,
    EuJustAdded,
    EuLeavingSoon,
    EuNewModel,
    EuPluginHybrid,
    EuPrototype,
    EuRedesign,
    EuSnowTires,
    IcAddCircle,
    IcArrowDown,
    IcArrowLeft,
    IcArrowRight,
    IcArrowUp,
    IcAttach,
    IcAttentionForm,
    IcAvailableDate,
    IcBodyType,
    IcBike,
    IcBooking,
    IcCalendar,
    IcCar,
    IcCarDamage,
    IcCheck,
    IcCheckIn,
    IcChevronDown,
    IcChevronLeft,
    IcChevronRight,
    IcChevronUp,
    IcClose,
    IcCopy,
    IcDamage,
    IcDdArrowDown,
    IcDdArrowUp,
    IcDoubleLeft,
    IcDoubleRight,
    IcDownload,
    IcDriversLicence,
    IcDrivetrain,
    IcEdit,
    IcEmail,
    IcEngine,
    IcExpenses,
    IcExport,
    IcExtraOptions,
    IcFile,
    IcFilter,
    IcFinishFlag,
    IcFuel,
    IcHide,
    IcHome,
    IcImport,
    IcInfo,
    IcInterior,
    IcKeys,
    IcLink,
    IcLogout,
    IcMedia,
    IcMediaAdd,
    IcMileage,
    IcMinus,
    IcMobile,
    IcNewDamage,
    IcNoResults,
    IcNotes,
    IcOrder,
    IcOverview,
    IcPhone,
    IcPin,
    IcPlate,
    IcPlus,
    IcPrint,
    IcRating,
    IcRefresh,
    IcRelease,
    IcReminder,
    IcRetireDate,
    IcRideReport,
    IcSChevronLeft,
    IcSChevronRight,
    IcSearch,
    IcSettings,
    IcShow,
    IcSpecsheet,
    IcSuccessForm,
    IcSurvey,
    IcTag,
    IcTeam,
    IcTires,
    IcTracking,
    IcTracker,
    IcVehicle,
    IcTransmission,
    IcTrash,
    IcUpcoming,
    IcUpload,
    IcUsageActive,
    IcUsageInactive,
    IcUsageRetired,
    IcUser,
    IcUserApprove,
    IcUserDeactivate,
    IcUserReject,
    IcUserRequest,
    IcUtilizationHigh,
    IcUtilizationLow,
    IcWarranty,
    IcXCircle,
    VCToronto,
    VCBase,
    VCMontreal,
    VCVancouver,
    PoolCompany,
    PoolFleet,
    PoolGeneral,
    PoolMarketing,
    PoolPress,
    PoolTesting,
    IcInstagram,
    IcTwitter,
    IcFacebook,
    IcYoutube,
    IcLinkedIn,
    IcIncoming,
    IcClock
} from './ic';

const components = {
    AddCircle: IcAddCircle,
    ArrowDown: IcArrowDown,
    ArrowLeft: IcArrowLeft,
    ArrowRight: IcArrowRight,
    ArrowUp: IcArrowUp,
    Attach: IcAttach,
    AttentionForm: IcAttentionForm,
    AvailableDate: IcAvailableDate,
    Bike: IcBike,
    BodyType: IcBodyType,
    Booking: IcBooking,
    Calendar: IcCalendar,
    Car: IcCar,
    CarDamage: IcCarDamage,
    Check: IcCheck,
    CheckIn: IcCheckIn,
    ChevronDown: IcChevronDown,
    ChevronLeft: IcChevronLeft,
    ChevronRight: IcChevronRight,
    ChevronUp: IcChevronUp,
    Close: IcClose,
    Copy: IcCopy,
    Damage: IcDamage,
    DdArrowDown: IcDdArrowDown,
    DdArrowUp: IcDdArrowUp,
    DoubleLeft: IcDoubleLeft,
    DoubleRight: IcDoubleRight,
    Download: IcDownload,
    DriversLicence: IcDriversLicence,
    Drivetrain: IcDrivetrain,
    Edit: IcEdit,
    Email: IcEmail,
    Engine: IcEngine,
    Expenses: IcExpenses,
    Export: IcExport,
    ExtraOptions: IcExtraOptions,
    File: IcFile,
    Filter: IcFilter,
    FinishFlag: IcFinishFlag,
    Fuel: IcFuel,
    Hide: IcHide,
    Home: IcHome,
    Import: IcImport,
    Info: IcInfo,
    Interior: IcInterior,
    Keys: IcKeys,
    Link: IcLink,
    Logout: IcLogout,
    Media: IcMedia,
    MediaAdd: IcMediaAdd,
    Mileage: IcMileage,
    Minus: IcMinus,
    Mobile: IcMobile,
    NewDamage: IcNewDamage,
    NoResults: IcNoResults,
    Notes: IcNotes,
    Order: IcOrder,
    Overview: IcOverview,
    Phone: IcPhone,
    Pin: IcPin,
    Plate: IcPlate,
    Plus: IcPlus,
    Print: IcPrint,
    Rating: IcRating,
    Refresh: IcRefresh,
    Release: IcRelease,
    Reminder: IcReminder,
    RetireDate: IcRetireDate,
    RideReport: IcRideReport,
    SChevronLeft: IcSChevronLeft,
    SChevronRight: IcSChevronRight,
    Search: IcSearch,
    Settings: IcSettings,
    Show: IcShow,
    Specsheet: IcSpecsheet,
    SuccessForm: IcSuccessForm,
    Survey: IcSurvey,
    Tag: IcTag,
    Team: IcTeam,
    Tires: IcTires,
    Tracking: IcTracking,
    Tracker: IcTracker,
    Vehicle: IcVehicle,
    Transmission: IcTransmission,
    Trash: IcTrash,
    Upcoming: IcUpcoming,
    Upload: IcUpload,
    UsageActive: IcUsageActive,
    UsageInactive: IcUsageInactive,
    UsageRetired: IcUsageRetired,
    User: IcUser,
    UserApprove: IcUserApprove,
    UserDeactivate: IcUserDeactivate,
    UserReject: IcUserReject,
    UserRequest: IcUserRequest,
    UtilizationHigh: IcUtilizationHigh,
    UtilizationLow: IcUtilizationLow,
    Warranty: IcWarranty,
    XCircle: IcXCircle,
    VCBase: VCBase,
    VCToronto: VCToronto,
    VCMontreal: VCMontreal,
    VCVancouver: VCVancouver,
    PoolCompany: PoolCompany,
    PoolFleet: PoolFleet,
    PoolGeneral: PoolGeneral,
    PoolMarketing: PoolMarketing,
    PoolPress: PoolPress,
    PoolTesting: PoolTesting,
    EuAwd: EuAwd,
    EuElectric: EuElectric,
    EuHybrid: EuHybrid,
    EuJustAdded: EuJustAdded,
    EuLeavingSoon: EuLeavingSoon,
    EuNewModel: EuNewModel,
    EuPluginHybrid: EuPluginHybrid,
    EuPrototype: EuPrototype,
    EuRedesign: EuRedesign,
    EuSnowTires: EuSnowTires,
    Instagram: IcInstagram,
    Twitter: IcTwitter,
    LinkedIn: IcLinkedIn,
    Facebook: IcFacebook,
    Youtube: IcYoutube,
    Incoming: IcIncoming,
    Clock: IcClock,
};


const Icon = (props) => {
    let defaultStyle = { fontSize: props.size, justifyContent: 'inherit', display: 'inherit', alignItems: 'inherit', height: props.height ? props.height : props.size, width: props.width ? props.width : props.size };

    if (Object.keys(components).includes(props.name)) {
        if (props.size) {
            return (
                <div className={props.class || ''} style={props.style ? Object.assign({}, defaultStyle, props.style) : defaultStyle} onClick={props.onClick ? props.onClick : null}>
                    {React.createElement(components[props.name])}
                </div>
            )
        }
        return React.createElement(components[props.name]);
    } else {
        return null;
    }
}

Icon.defaultProps = {
    size: 24,
    name: 'Hide',
    onClick: null,
    width: null,
    height: null,
    class: null,
};

Icon.propTypes = {
    size: PropTypes.number.isRequired,
    name: PropTypes.oneOf(Object.keys(components)).isRequired,
    onClick: PropTypes.func,
    width: PropTypes.number,
    height: PropTypes.number,
    class: PropTypes.string,
}

export default Icon;